import {User} from 'APIs/letrusAPI/user/types';
import {hubspotTokenToIdentifyUserToWebChat} from 'utils/libs/analytics';
import loadWidget from './loadWidget';

async function setupUserHubspotConversation(user: User): Promise<void> {
  const filteredUserEmail = user.email.replace(' ', '');
  const tokenFromLocalStorage = localStorage.getItem('HubSpot_Token');

  if (tokenFromLocalStorage) {
    loadWidget({
      email: filteredUserEmail,
      token: tokenFromLocalStorage,
    });
  } else {
    const hubspotAuthenticationResponse =
      await hubspotTokenToIdentifyUserToWebChat();

    if (hubspotAuthenticationResponse?.token) {
      localStorage.setItem(
        'HubSpot_Token',
        hubspotAuthenticationResponse.token,
      );

      if (window.HubSpotConversations) {
        loadWidget({
          email: filteredUserEmail,
          token: hubspotAuthenticationResponse.token,
        });
      }
    }
  }
}

export default setupUserHubspotConversation;
